import api from '@/utils/api'
import { constructFilter } from '@/utils/servicesUtil'

export default {
    getTransactionalMessages(filters) {
        return api.get(`transactional/viber${constructFilter(filters)}`)
    },
    getTransactionalMessageById(id, filters) {
        return api.get(`transactional/viber/${id}${constructFilter(filters)}`)
    }
}
